import { Modal, Result, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  UserOutlined,
  EuroOutlined,
  CalendarOutlined,
  GoldOutlined,
  MinusCircleOutlined,
  WalletOutlined,
  BankOutlined,
  TagOutlined,
  IdcardOutlined,
  CloseCircleOutlined,
  RetweetOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { getUserById } from "../../redux/userSlice";
import { getKioskById } from "../../redux/kiosksSlice";

const { Paragraph } = Typography;

function SummaryModal({
  isModalOpen,
  handleCancel,
  selectedDriver,
  selectedDate,
  selectedKiosk,
  totalSummary,
}) {
  console.log("selectedDriver", selectedDriver);
  console.log("selectedDate", selectedDate);
  console.log("selectedKiosk", selectedKiosk);
  const [userDetails, setUserDetails] = useState(null);
  const [kioskDetails, setKioskDetails] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const promisAllAndFetchDriverAndKioskDetails = async () => {
      const promis = [];
      if (selectedDriver) {
        promis.push(
          dispatch(
            getUserById({
              userId: selectedDriver,
            })
          )
        );
      }
      if (selectedKiosk) {
        promis.push(dispatch(getKioskById(selectedKiosk)));
      }
      await Promise.all(promis)
        .then((res) => {
          setUserDetails(res[0].payload);
          setKioskDetails(res[1].payload);
        })
        .catch((err) => {
          console.log("err", err);
        });
    };

    if (selectedDriver || selectedKiosk) {
      promisAllAndFetchDriverAndKioskDetails();
    }
  }, [selectedDriver, selectedKiosk, dispatch]);
  const { t } = useTranslation();
  // Use transactions from props instead of Redux to work with filtered data

  /* const calculateTotalEarnings = () => {
    let total = transactions.reduce((acc, transaction) => {
      return acc + transaction?.totalAmount;
    }, 0);
    return total?.toFixed(2);
  };
  const calculateTotalEarningsByCard = () => {
    const cash = transactions.filter(
      (transaction) => transaction?.paymentType === "CARD"
    );
    let total = cash.reduce((acc, transaction) => {
        return acc + transaction?.totalAmount;
    }, 0);
    return total?.toFixed(2);
  };
  const calculateTotalEarningsByCash = () => {
    const cash = transactions.filter(
      (transaction) => transaction?.paymentType === "CASH"
    );
    let total = cash.reduce((acc, transaction) => {
        return acc + transaction?.totalAmount;
    }, 0);
    return total?.toFixed(2);
  };
  const calculateTotalNumberOfTickets = () => {
    return transactions.reduce((acc, transaction) => {
      if (transaction?.type === "TICKET_TYPE") {
        if (transaction?.tickets?.length > 0)
          return acc + transaction?.tickets?.length;
        else return acc + 1; // Fallback: treat as 1 ticket if no tickets array
      }
      return acc;
    }, 0);
  };

  const calculateTicketsCashPayments = () => {
    const cashTickets = transactions.filter(
      (transaction) =>
        transaction?.type === "TICKET_TYPE" &&
        transaction?.paymentType === "CASH"
    );
    const count = cashTickets.reduce((acc, transaction) => {
      if (transaction?.tickets?.length > 0)
        return acc + transaction?.tickets?.length;
      else return acc + 1; // Fallback: treat as 1 ticket if no tickets array
    }, 0);
    const amount = cashTickets.reduce((acc, transaction) => {
      return acc + (transaction?.totalAmount || 0);
    }, 0);
    return { count, amount: amount.toFixed(2) };
  };
  const calculateTicketsCardPayments = () => {
    const cardTickets = transactions.filter(
      (transaction) =>
        transaction?.type === "TICKET_TYPE" &&
        transaction?.paymentType === "CARD"
    );
    const count = cardTickets.reduce((acc, transaction) => {
      if (transaction?.tickets?.length > 0)
        return acc + transaction?.tickets?.length;
      else return acc + 1; // Fallback: treat as 1 ticket if no tickets array
    }, 0);
    const amount = cardTickets.reduce((acc, transaction) => {
      return acc + (transaction?.totalAmount || 0);
    }, 0);
    return { count, amount: amount.toFixed(2) };
  };
  const calculateCardReplacementPayments = () => {
    const cardTickets = transactions.filter(
      (transaction) =>
        transaction?.type === "CARD_REPLACEMENT_FEE" &&
        transaction?.paymentType === "CARD"
    );
    const count = cardTickets.reduce((acc, transaction) => {
      if (transaction?.tickets?.length > 0)
        return acc + transaction?.tickets?.length;
      else return acc + 1; // Fallback: treat as 1 ticket if no tickets array
    }, 0);
    const amount = cardTickets.reduce((acc, transaction) => {
      return acc + (transaction?.totalAmount || 0);
    }, 0);
    return { count, amount: amount.toFixed(2) };
  };
  const calculateCardReplacementCashPayments = () => {
    const cardTickets = transactions.filter(
      (transaction) =>
        transaction?.type === "CARD_REPLACEMENT_FEE" &&
        transaction?.paymentType === "CASH"
    );
    const count = cardTickets.reduce((acc, transaction) => {
      if (transaction?.tickets?.length > 0)
        return acc + transaction?.tickets?.length;
      else return acc + 1; // Fallback: treat as 1 ticket if no tickets array
    }, 0);
    const amount = cardTickets.reduce((acc, transaction) => {
      return acc + (transaction?.totalAmount || 0);
    }, 0);
    return { count, amount: amount.toFixed(2) };
  };
  const calculateCardsCashPayments = () => {
    const cashCards = transactions.filter(
      (transaction) =>
        (transaction?.type === "TOP_UP_CARD_TYPE" ||
          transaction?.type === "NEW_CARD_TYPE" ||
          transaction?.type === "SPECIAL_CARD_TYPE") &&
        transaction?.paymentType === "CASH"
    );
    const count = cashCards.length;
    const amount = cashCards.reduce((acc, transaction) => {
      return acc + (transaction?.totalAmount || 0);
    }, 0);
    return { count, amount: amount.toFixed(2) };
  };
  const calculateCardsCardPayments = () => {
    const cardCards = transactions.filter(
      (transaction) =>
        (transaction?.type === "TOP_UP_CARD_TYPE" ||
          transaction?.type === "NEW_CARD_TYPE" ||
          transaction?.type === "SPECIAL_CARD_TYPE") &&
        transaction?.paymentType === "CARD"
    );
    const count = cardCards.length;
    const amount = cardCards.reduce((acc, transaction) => {
      return acc + (transaction?.totalAmount || 0);
    }, 0);
    return { count, amount: amount.toFixed(2) };
  };
  const calculateTotalNumberOfCards = () => {
    return transactions.filter(
      (transaction) =>
        transaction?.type === "TOP_UP_CARD_TYPE" ||
        transaction?.type === "NEW_CARD_TYPE" ||
        transaction?.type === "SPECIAL_CARD_TYPE"
    ).length;
  };
  const calculateTotalNumberOfTicketTransactions = () => {
    return transactions.filter(
      (transaction) => transaction?.type === "TICKET_TYPE"
    ).length;
  };

  const calculateTotalNumberOfCardTransactions = () => {
    return transactions.filter(
      (transaction) =>
        transaction?.type === "TOP_UP_CARD_TYPE" ||
        transaction?.type === "NEW_CARD_TYPE" ||
        transaction?.type === "SPECIAL_CARD_TYPE"
    ).length;
  };

  const calculateTotalNumberOfCancelledTickets = () => {
    return transactions.reduce((acc, transaction) => {
      if (transaction?.tickets?.length > 0) {
        const cancelledTickets = transaction.tickets.filter(
          (ticket) => ticket.cancelled
        );
        return acc + cancelledTickets.length;
      }
      return acc;
    }, 0);
  }; */
  return (
    <Modal
      title={t("transactionSummary.title")}
      open={isModalOpen}
      onCancel={handleCancel}
      footer={null}
      width={600}
      centered
      style={{ top: 20 }}
    >
      <Result status="info" title={t("transactionSummary.title")}>
        {" "}
        <div className="desc">
          {" "}
          <Paragraph>
            <TagOutlined className="site-result-demo-error-icon" />{" "}
            {t("transactionSummary.totalTransactions")}{" "}
            <a role="button" tabIndex={0} onClick={(e) => e.preventDefault()}>
              {totalSummary?.totalTransactions}
            </a>
          </Paragraph>
          <Paragraph>
            <TagOutlined className="site-result-demo-error-icon" />{" "}
            {t("transactionSummary.totalTickets")}{" "}
            <a role="button" tabIndex={0} onClick={(e) => e.preventDefault()}>
              {totalSummary?.totalTicketsIssued}
            </a>
          </Paragraph>
          {totalSummary?.totalTicketsIssued > 0 && (
            <>
              {" "}
              <Paragraph>
                <WalletOutlined className="site-result-demo-error-icon" />{" "}
                {t("transactionSummary.totalTicketsCash")}{" "}
                <a
                  role="button"
                  tabIndex={0}
                  onClick={(e) => e.preventDefault()}
                >
                  {totalSummary?.totalCountTicketsPaidCash} (€
                  {totalSummary?.totalTicketsPaidCash})
                </a>
              </Paragraph>
              <Paragraph>
                <BankOutlined className="site-result-demo-error-icon" />{" "}
                {t("transactionSummary.totalTicketsCard")}{" "}
                <a
                  role="button"
                  tabIndex={0}
                  onClick={(e) => e.preventDefault()}
                >
                  {totalSummary?.totalCountTicketsPaidCard} (€
                  {totalSummary?.totalTicketsPaidCard})
                </a>
              </Paragraph>
            </>
          )}{" "}
          <Paragraph>
            <CloseCircleOutlined className="site-result-demo-error-icon" />{" "}
            {t("transactionSummary.totalTicketsCancelled")}{" "}
            <a role="button" tabIndex={0} onClick={(e) => e.preventDefault()}>
            {totalSummary?.totalCancelledTickets}
            </a>
          </Paragraph>
          {/* <Paragraph>
            <IdcardOutlined className="site-result-demo-error-icon" />{" "}
            {t("transactionSummary.totalCardTransactions")}{" "}
            <a role="button" tabIndex={0} onClick={(e) => e.preventDefault()}>
              {totalSummary?.totalCardsIssued}
            </a>
          </Paragraph> */}
          <Paragraph>
            <IdcardOutlined className="site-result-demo-error-icon" />{" "}
            {t("transactionSummary.totalCards")}{" "}
            <a role="button" tabIndex={0} onClick={(e) => e.preventDefault()}>
            {totalSummary?.totalCardsIssued}
            </a>
          </Paragraph>
          {totalSummary?.totalCardsIssued > 0 && (
            <>
              {" "}
              <Paragraph>
                <WalletOutlined className="site-result-demo-error-icon" />{" "}
                {t("transactionSummary.totalSpecialCards")}{" "}
                <a
                  role="button"
                  tabIndex={0}
                  onClick={(e) => e.preventDefault()}
                >
                  {totalSummary?.totalSpecialCardsIssued}
                </a>
              </Paragraph>
              <Paragraph>
                <WalletOutlined className="site-result-demo-error-icon" />{" "}
                {t("transactionSummary.totalStandardCards")}{" "}
                <a
                  role="button"
                  tabIndex={0}
                  onClick={(e) => e.preventDefault()}
                >
                  {totalSummary?.totalStandardCardsIssued}
                </a>
              </Paragraph>
              <Paragraph>
                <WalletOutlined className="site-result-demo-error-icon" />{" "}
                {t("transactionSummary.totalCardsCash")}{" "}
                <a
                  role="button"
                  tabIndex={0}
                  onClick={(e) => e.preventDefault()}
                >
                  {totalSummary?.totalCountCardsPaidCash} (€
                  {totalSummary?.totalCardsPaidCash})
                </a>
              </Paragraph>
              <Paragraph>
                <BankOutlined className="site-result-demo-error-icon" />{" "}
                {t("transactionSummary.totalCardsCard")}{" "}
                <a
                  role="button"
                  tabIndex={0}
                  onClick={(e) => e.preventDefault()}
                >
                  {totalSummary?.totalCountCardsPaidCard} (€
                  {totalSummary?.totalCardsPaidCard})
                </a>
              </Paragraph>
            </>
          )}{" "}
          <Paragraph>
            <RetweetOutlined className="site-result-demo-error-icon" />{" "}
            {t("transactionSummary.totalCardsReplacementCard")}{" "}
            <a 
              role="button" 
              tabIndex={0} 
              onClick={(e) => e.preventDefault()}
              //style={{ fontWeight: "bold", color: "#1890ff" }}
            >
                {totalSummary?.totalCountCardReplacementPaidCard} (€
                {totalSummary?.totalCardReplacementPaidCard})
            </a>
          </Paragraph>
          <Paragraph>
          <RetweetOutlined className="site-result-demo-error-icon"/>
          {" "}
            {t("transactionSummary.totalCardsReplacementCash")}{" "}
            <a 
              role="button" 
              tabIndex={0} 
              onClick={(e) => e.preventDefault()}
              //style={{ fontWeight: "bold", color: "#1890ff" }}
            >
              {totalSummary?.totalCountCardReplacementPaidCash} (€
              {totalSummary?.totalCardReplacementPaidCash})
            </a>
          </Paragraph>
          <Paragraph>
            <EuroOutlined className="site-result-demo-error-icon"/>{" "}
              {t("transactionSummary.totalEarnings")}{" "}
              <a 
                role="button" 
                tabIndex={0} 
                onClick={(e) => e.preventDefault()}
                style={{ fontWeight: "bold", color: "#1890ff" }}
              >
                {totalSummary?.totalEarnings} EUR
              </a>
          </Paragraph>
          <Paragraph>
            <EuroOutlined className="site-result-demo-error-icon"/>{" "}
              {t("transactionSummary.totalEarningsByCard")}{" "}
              <a 
                role="button" 
                tabIndex={0} 
                onClick={(e) => e.preventDefault()}
                style={{ fontWeight: "bold", color: "#1890ff" }}
              >
                {totalSummary?.totalEarningsCard} EUR
              </a>
          </Paragraph>
          <Paragraph>
            <EuroOutlined className="site-result-demo-error-icon"/>{" "}
              {t("transactionSummary.totalEarningsByCash")}{" "}
              <a 
                role="button" 
                tabIndex={0} 
                onClick={(e) => e.preventDefault()}
                style={{ fontWeight: "bold", color: "#1890ff" }}
              >
                {totalSummary?.totalEarningsCash} EUR
              </a>
          </Paragraph>          
          <Paragraph>
            <UserOutlined className="site-result-demo-error-icon" />{" "}
            {t("transactionSummary.selectedDriver")}{" "}
            <a 
              role="button" 
              tabIndex={0} 
              onClick={(e) => e.preventDefault()}
              style={{ fontWeight: "bold", color: "#1890ff" }}
            >
              {selectedDriver ? (
                userDetails?.name + " " + userDetails?.surname
              ) : (
                <MinusCircleOutlined />
              )}
            </a>
          </Paragraph>          <Paragraph>
            <CalendarOutlined className="site-result-demo-error-icon" />{" "}
            {t("transactionSummary.selectedDateRange")}{" "}
            <a 
              role="button" 
              tabIndex={0} 
              onClick={(e) => e.preventDefault()}
              style={{ fontWeight: "bold", color: "#1890ff" }}
            >
              {selectedDate ? (
                dayjs(selectedDate[0]).format("DD/MM/YYYY") +
                " - " +
                dayjs(selectedDate[1]).format("DD/MM/YYYY")
              ) : (
                <MinusCircleOutlined />
              )}
            </a>
          </Paragraph>          <Paragraph>
            <GoldOutlined className="site-result-demo-error-icon" />{" "}
            {t("transactionSummary.selectedKiosk")}{" "}
            <a 
              role="button" 
              tabIndex={0} 
              onClick={(e) => e.preventDefault()}
              style={{ fontWeight: "bold", color: "#1890ff" }}
            >
              {selectedKiosk ? kioskDetails?.name : <MinusCircleOutlined />}
            </a>
          </Paragraph>
        </div>
      </Result>
    </Modal>
  );
}

export default SummaryModal;
